
function getValueConfiguration(conf) {
  if (conf.type_field == 'check') {
    if (conf.value_conf == 'true') {
      return true;
    } else {
      return false;
    }
  } else if (conf.type_field == 'number' || conf.type_field == 'money') {
    return parseFloat(conf.value_conf);
  }
  return conf.value_conf;
}

const CLAVE_SUCURSAL = 'sucursal_pantalla';

/**
 * La sucursal de la pantalla de cocina se queda en el equipo: al recargar o reiniciar no se vuelve a pedir.
 * Solo vale con la empresa y la sesión con las que se eligió (otro usuario en el mismo equipo no hereda la de otro).
 */
function leerSucursalGuardada() {
  try {
    const guardada = JSON.parse(localStorage.getItem(CLAVE_SUCURSAL));
    if (guardada && guardada.store && localStorage.getItem('source_tk') && String(guardada.tenant) === String(localStorage.getItem('tenant'))) {
      return guardada.store;
    }
  } catch (e) {
    // sin almacenamiento, o datos dañados: se pide la sucursal otra vez
  }
  return null;
}

/**
 * El logo del recibo viaja en base64 dentro de los datos de la empresa y se guarda en el navegador:
 * si en otra carga el servidor no lo manda (el archivo no estaba, o el POS arrancó sin conexión), se
 * imprime con el último que se tuvo en vez de sin logo. Una empresa sin logo borra el guardado.
 */
function conservarLogo(empresa) {
  if (!empresa || !empresa.id) {
    return empresa;
  }
  const clave = 'logo_b64_' + empresa.id;
  try {
    if (empresa.logo_b64) {
      localStorage.setItem(clave, empresa.logo_b64);
    } else if (!empresa.logo) {
      localStorage.removeItem(clave);
    } else {
      const guardado = localStorage.getItem(clave);
      if (guardado) {
        return { ...empresa, logo_b64: guardado };
      }
    }
  } catch (e) {
    // sin almacenamiento o sin espacio: se imprime con lo que mande el servidor
  }
  return empresa;
}

function guardarSucursal(store) {
  try {
    if (store) {
      localStorage.setItem(CLAVE_SUCURSAL, JSON.stringify({ tenant: localStorage.getItem('tenant'), store }));
    } else {
      localStorage.removeItem(CLAVE_SUCURSAL);
    }
  } catch (e) {
    // la pantalla funciona igual, solo no se recuerda
  }
}

export default {
  state: {
    configurations: {},
    loading: false,
    error: null,
    message: null,
    mobile: false,
    aspect_ratio: null,
    drawer: false,
    user: null,
    menu: null,
    store: leerSucursalGuardada(), // sucursal de la pantalla de cocina (se recuerda en el equipo)
    turn: null, // turno en session para pos se consulta en cada reload de la pagina 
    company: null,
    lists: new Map(),
    online: true,
    printData: null,
    installation: null,
    tables: [],
    agent: false,
    order_received: false,
    payment_announcement: false,
    equipo_rechazado: false, // la caja de este equipo está instalada en otro (POS.EQUIPO.*)
    order_changed: 1,
    order_created: 1,
    filters: new Map(),

  },
  mutations: {
    setAgent(state, payload) {
      state.agent = payload
    },
    setUser(state, payload) {
      state.user = payload
    },
    setTurn(state, payload) {
      state.turn = payload
    },
    setCompany(state, payload) {
      state.company = conservarLogo(payload)
    },
    setStore(state, payload) {
      state.store = payload
      guardarSucursal(payload)
    },
    setOrderReceived(state, payload) {
      state.order_received = payload
    },
    setOrderChanged(state, payload) {
      state.order_changed = state.order_changed + 1
    },
    orderChanged(state, val) {

      state.order_changed = state.order_changed + 1;
      //console.log('order change......................', state.orderChanged)
    },
    createdOrder(state, val) {

      state.order_created = state.order_created + 1;
      //console.log('order change......................', state.orderChanged)
    },
    setInstallation(state, payload) {
      state.installation = payload
    }, setEquipoRechazado(state, payload) {
      state.equipo_rechazado = payload
    }, setPaymentAnnouncement(state, payload) {
      state.payment_announcement = payload
    },
    setConfigurations(state, payload) {
      state.configurations = payload
    },
    updateConfiguration(state, cnf) {
      if (cnf.is_global) {
        state.configurations[cnf.name] = cnf;
      } else {
        if (cnf.require_subsidiary) {
          state.configurations[cnf.name + '_sub_' + cnf.bus_subsidiary_id] = cnf;
        } else {
          if (cnf.object_type != '') {
            state.configurations[cnf.name + '_' + cnf.object_type + '_' + cnf.object_id] = cnf;
          }
        }
      }
      //state.printData = payload;
    },
    setMessage(state, payload) {
      state.message = payload
    },
    setLoading(state, payload) {
      state.loading = payload
    },
    setError(state, payload) {
      state.error = payload
    },
    clearError(state) {
      state.error = null
    },
    setAspectRatio(state, payload) {
      state.aspect_ratio = payload
    },
    setMobile(state, payload) {
      state.mobile = payload
    },
    setMenu(state, payload) {
      state.menu = payload
    },

    setDrawer(state, payload) {
      state.drawer = payload
    },
    toggle(state, payloa) {
      state.drawer = !state.drawer;
    },
    online(state, payloa) {
      state.online = payloa;
    },
    printData(state, payloa) {
      state.printData = payloa;
    },
    addList(state, list) {
      if (list && list.path) {
        state.lists.set(list.path, { items: list.items, last: (new Date()).getTime() });
      }
    },
    addFilter(state, filter) {
      if (filter && filter.path) {
        state.filters.set(filter.path, filter.values);
      }
    },
  },
  actions: {
    setConfigurations({ commit }, payload) {
      commit('setConfigurations', payload)
    },
    async logoutAuth({ commit }) {
      //firebase.auth().signOut()
      // El token deja de servir también en la nube (PLAN-ASEGURAR-POS.md, 4.2); antes sólo se borraba aquí. Sin
      // conexión no se espera más de 3 s: la sesión se cierra en la caja igual.
      const http = this._vm && this._vm.$http;
      if (http && localStorage.getItem('source_tk')) {
        const espera = new Promise((resolve) => setTimeout(resolve, 3000));
        await Promise.race([http.post('api/v1/auth/logout', {}, false, false, false).catch(() => null), espera]);
      }
      localStorage.removeItem('filters_module');
      localStorage.removeItem('source_tk');
      localStorage.removeItem('sk');
      localStorage.removeItem('profile');
      guardarSucursal(null);
      commit('setUser', null)
      //console.log('logout')
      window.location.href = '/'
    },
    setOrderReceived({ commit }, payload) {
      commit('setOrderReceived', payload)
    },
    createdOrder({ commit }, payload) {
      commit('createdOrder', payload)
    },

    /*setOrderReceived({ commit }, payload) {
      commit('setOrderReceived', payload)
    },*/
    clearError({ commit }) {
      commit('clearError')
    },
    setError({ commit }, payload) {
      commit('setError', payload)
    },
    online({ commit }, payload) {
      commit('online', payload)
    },
    printData({ commit }, payload) {
      commit('printData', payload)
    },
    setInstallation({ commit }, payload) {
      commit('setInstallation', payload)
    },
    updateConfiguration({ commit }, payload) {
      commit('updateConfiguration', payload)
    },
    addFilter({ commit }, payload) {
      commit('addFilter', payload)
    }
  },
  getters: {
    agent: state => state.agent,
    configurations: state => state.configurations,
    installation: state => state.installation,
    getGeneralValue: (state) => (name) => {
      if (!state.installation) {
        return null;
      }
      if (!state.configurations[name]) {
        return null;
      }
      return getValueConfiguration(state.configurations[name]);
    },
    getSubsidiaryValue: (state) => (name) => {
      if (!state.installation) {
        return null;
      }
      let key = name + '_' + state.installation.subsidiary_id;
      if (!state.configurations[key]) {
        return null;
      }
      return getValueConfiguration(state.configurations[key]);
    },

    getPosValue: (state) => (name) => {
      //console.log(state.installation)
      if (!state.installation) {
        return null;
      }
      let key = name + '_\\App\\Models\\BillCashRegister' + '_' + state.installation.cash_id;
      if (!state.configurations[key]) {
        return null;
      }
      return getValueConfiguration(state.configurations[key]);
    },
    printData: state => state.printData,
    payment_announcement: state => state.payment_announcement,
    equipo_rechazado: state => state.equipo_rechazado,
    online: state => state.online,
    mobile: state => state.mobile,
    aspect_ratio: state => state.aspect_ratio,
    company: state => state.company,
    turn: state => {
      return state.turn
    },
    user: state => state.user,
    tables: state => state.tables,
    isRoot: state => {
      return state.user.rol.name == 'Root'
    },
    orderReceived: state => {
      return state.order_received
    },
    orderChanged: state => {
      return state.order_changed
    },
    orderCreated: state => {
      return state.order_created
    },

    store: state => {
      return state.store
    },
    isRestaurant: state => {
      return state.company && state.company.type.id == 2;
    },
    isDrugStore: state => {
      return state.company && state.company.type.id == 3;
    },
    menu: state => state.menu,
    drawer: state => state.drawer,
    getList: (state) => (path) => {
      if (!state.lists.has(path)) {
        return null;
      }
      return state.lists.get(path);
    },
    getFilter: (state) => (name) => {
      if (!state.filters.has(name)) {
        return {};
      }
      return state.filters.get(name);
    },
    message(state) {
      return state.message
    },
    loading(state) {
      return state.loading
    },
    error(state) {
      return state.error
    }
  }
}
